import { render, staticRenderFns } from "./CompanyChartTv.vue?vue&type=template&id=67554c2a&scoped=true"
import script from "./CompanyChartTv.vue?vue&type=script&lang=js"
export * from "./CompanyChartTv.vue?vue&type=script&lang=js"
import style0 from "./CompanyChartTv.vue?vue&type=style&index=0&id=67554c2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67554c2a",
  null
  
)

export default component.exports